import { useState } from "react";

const useStepper = () => {
  const [slide, setSlide] = useState(0);

  const handleSlideChange = (index: number) => {
    setSlide(index);
  };

  const handleNextSlide = () => {
    setSlide(slide + 1);
  };

  return {
    slide,
    handleSlideChange,
    handleNextSlide,
  };
};

export default useStepper;
